/**
 * @param {*} value
 * @returns {value is Function}
 */
export function isFunction(value) {
  return typeof value === 'function';
}
